import { atom } from "recoil";

export const hideNavbarState = atom<boolean>({
    key: "hideNavbarState",
    default: false,
});
